export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
};
